module.exports = __webpack_public_path__ + "1bbbabd306ec8e8f5ed1e65c573892ed.png";